/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MountedMaterialForwardSearchTrace } from '../../models/mounted-material-forward-search-trace';

export interface GetMountedMaterialTraceForForwardSearch$Params {
  productionOrderId: number;
  viewMode?: string;
}

export function getMountedMaterialTraceForForwardSearch(http: HttpClient, rootUrl: string, params: GetMountedMaterialTraceForForwardSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MountedMaterialForwardSearchTrace>>> {
  const rb = new RequestBuilder(rootUrl, getMountedMaterialTraceForForwardSearch.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.query('viewMode', params.viewMode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MountedMaterialForwardSearchTrace>>;
    })
  );
}

getMountedMaterialTraceForForwardSearch.PATH = '/api/v1/getMountedMaterialTraceForForwardSearch/{productionOrderId}';
